export enum NutrientType {
    Energy = 0,
    Fat = 1,
    SaturatedFattyAcids = 2,
    TransFattyAcids = 3,
    Cholesterol = 4,
    Sodium = 5,
    Carbohydrate = 6,
    Fibre = 7,
    Sugars = 8,
    Protein = 9,
    VitaminD = 10,
    Potassium = 11,
    Calcium = 12,
    Iron = 13,
    AddedSugar = 14,
    SugarAlcohols = 15,
    VitaminC = 16,
    VitaminA = 18,
    Erythritol = 30,
    Isomalt = 31,
    Lactitol= 32,
    Mannitol = 33,
    Sorbitol = 34,
    Xylitol = 35,
    Maltitol = 36,
    UnspecifiedSugarAlcohol = 37,
    MonoUnsaturatedFats = 38,
    PolyUnsaturatedFats = 39,
    Omega3 = 40,
    Omega6 = 41,
    Biotin = 42,
    Choline = 43,
    Folate = 44,
    FolateDfe = 45,
    Niacin = 46,
    NiacinEq = 47,
    NiacinVitb3Eq = 48,
    PantothenicAcid = 49,
    Riboflavin = 50,
    Thiamine = 51,
    BetaCarotene = 52,
    Retinol = 53,
    VitaminB12 = 54, // (Vitamin D, another form)
    VitaminE = 55,
    VitaminEToco = 56,
    VitaminETocoEq = 57,
    VitaminK = 58,
    Chromium = 59,
    Chloride = 60,
    Copper = 61,
    Iodine = 62,
    Magnesium = 63,
    Manganese = 64,
    Molybdenum = 65,
    Phosphorus = 66,
    Selenium = 67,
    Zinc = 68,
    LAlanine = 69,
    LArginine = 70,
    LAsparagine = 71,
    LAsparticAcid = 72,
    LCysteine = 73,
    LGlutamicAcid = 74,
    LGlutamine = 75,
    Glycine = 76,
    LHistidine = 77,
    LIsoleucine = 78,
    LLeucine = 79,
    LLysine = 80,
    LMethionine = 81,
    LPhenylalanine = 82,
    LProline = 83,
    LSerine = 84,
    LThreonine = 85,
    LTyrosine = 86,
    LValine = 87,
    Caffeine = 88,
    GreenTeaExtract = 89,
    Taurine = 90,
    Ash = 91,
    Moisture = 92,
    Phosphatidylserine = 93,
    VitaminB6 = 94,
    FolicAcid = 95,
    Boron = 96,
    Fluoride = 97,
    Tryptophan = 98,
    Other = 99,
    SaturatedAndTrans = 100
}